import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Caption } from 'views/mutual/caption';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { DisplayItemProps, useEntryConfirm, EntryConfirmProps } from './hooks';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { CheckLabel, CheckLabelTextSize } from 'views/mutual/checkLabel';


export const EntryConfirm = (props: EntryConfirmProps) => {
  const { agreeToAccountOpenProfileDetailsProps, execute, goBack, displayInfo } = useEntryConfirm(props);
  useCustomLocationName('口座開設申込みフォーム');

  return (
    <div className="accountOpenTemplate">
      {!props.isUpdate && (
        <>
          <Caption label="申込確認内容" />
          <Description
            label={
              <>                
                <a
                  className="accountOpenTemplate_input_wrapper_link"
                  href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  FPGオンライン取引・電子署名取引一般規約
                </a>
                に同意し、口座開設を申し込みます。
              </>
            }
            labelColor={labelColor.black}
            labelSize={labelSize.large}
          />
        </>
      )}

      <div className="accountOpenTemplate_result">
        <Caption label="法人情報" />
        {displayInfo.corporateInfo.map((lv) => (
          <DisplayItem {...lv} />
        ))}
      </div>

      <div className="accountOpenTemplate_result">
        <Caption label="取引目的" />
        {displayInfo.transactionPurpose.map((lv) => (
          <DisplayItem {...lv} />
        ))}
      </div>

      <div className="accountOpenTemplate_result">
        <Caption label="連絡先情報" />
        {displayInfo.contactInfo.map((lv) => (
          <DisplayItem {...lv} />
        ))}
      </div>

      <div className="accountOpenTemplate_result">
        <Caption label="代表者情報" />
        {displayInfo.representInfo.map((lv) => (
          <DisplayItem {...lv} />
        ))}
      </div>

      <div className="accountOpenTemplate_result">
        <Caption label="取引担当者情報" />
        {displayInfo.dealerInfo.map((lv) => (
          <DisplayItem {...lv} />
        ))}
      </div>

      <div className="accountOpenTemplate_result">
        <Caption label="実質的支配者①" />
        {displayInfo.ruler1Info.map((lv) => (
          <DisplayItem {...lv} />
        ))}
      </div>

      {displayInfo.ruler2Info && (
        <div className="accountOpenTemplate_result">
          <Caption label="実質的支配者②" />
          {displayInfo.ruler2Info.map((lv) => (
            <DisplayItem {...lv} />
          ))}
        </div>
      )}

      {displayInfo.ruler3Info && (
        <div className="accountOpenTemplate_result">
          <Caption label="実質的支配者③" />
          {displayInfo.ruler3Info.map((lv) => (
            <DisplayItem {...lv} />
          ))}
        </div>
      )}
      
      {displayInfo.InvestorCategoryInfo && (
        <div className="accountOpenTemplate_result">
          <Caption label="投資家区分情報" />
          {displayInfo.InvestorCategoryInfo.map((lv) => (
            <DisplayItem {...lv} />
          ))}
        </div>
      )}

      {displayInfo.tfAuthentication && (
        <div className="accountOpenTemplate_result">
          <Caption label="2段階認証" />
          {displayInfo.tfAuthentication.map((lv) => (
            <DisplayItem {...lv} />
          ))}
        </div>
      )}

      {props.isUpdate && displayInfo.fatca && (
        <div className="accountOpenTemplate_result">
          <Caption label="米国納税義務（FATCA）に関する確認" />
          {displayInfo.fatca.map((lv) => (
            <DisplayItem {...lv} />
          ))}
        </div>
      )}

      {props.isUpdate && displayInfo.bankInfo && (
        <div className="accountOpenTemplate_result">
          <Caption label="配当金振込用口座" />
          {displayInfo.bankInfo.map((lv) => (
            <DisplayItem {...lv} />
          ))}
        </div>
      )}

      {props.isUpdate && displayInfo.invoiceNumber && (
        <div className="accountOpenTemplate_result">
          <Caption label="インボイス番号" />
          {displayInfo.invoiceNumber.map((lv) => (
            <DisplayItem {...lv} />
          ))}
        </div>
      )}

      {!props.isUpdate && (
        <div className='accountOpenTemplate_checkLabel'>
          <CheckLabel
          {...agreeToAccountOpenProfileDetailsProps}
          textSize={CheckLabelTextSize.Large}
          before="上記について変更が生じた場合には、貴社に届出ます"
          />
        </div>
      )}
      
      <div className="accountOpenTemplate_button">
        <Button
          type={ButtonType.Submit}
          label={props.isUpdate ? '登録情報変更を更新する' : '口座開設を申込む'}
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          disable={props.isUpdate ? false : !agreeToAccountOpenProfileDetailsProps.checked}
          {...execute}
        />
        <Button label="前の画面に戻る" buttonFill={ButtonFill.link} buttonSize={ButtonSize.small} {...goBack} />
      </div>
    </div>
  );
};

const DisplayItem = (props: DisplayItemProps) => {
  const { label, value, hidden } = props;
  if (hidden) return <></>;

  return (
    <>
      <div className="displayItem">
        <div className="displayItem_header">{label}</div>
        <div className="displayItem_body">{value}</div>
      </div>
    </>
  );
};
